import { render } from "./executiveChangeRequest.vue?vue&type=template&id=4747a23c&scoped=true"
import script from "./executiveChangeRequest.vue?vue&type=script&lang=js"
export * from "./executiveChangeRequest.vue?vue&type=script&lang=js"

import "./executiveChangeRequest.vue?vue&type=style&index=0&id=4747a23c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4747a23c"]])

export default __exports__